import React from 'react';

export function Favicon() {
  return (
    <>
      <link rel="icon" type="image/png" sizes="32x32" href="/static/favicon/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/static/favicon/favicon-16x16.png" />
      <link rel="icon" type="image/png" sizes="96x96" href="/static/favicon/favicon-48x48.png" />
      <meta name="msapplication-TileColor" content="#ffffff" />
      <meta name="msapplication-TileImage" content="/static/favicon/ms-icon-144x144.png" />
    </>
  );
}
